import type { DiscoverEvidenceBlock } from "../shared/source-contract";

export function GenericEvidenceCard({
  block,
  key,
}: {
  block: DiscoverEvidenceBlock;
  key: string;
}) {
  return (
    <div
      className="mb-6 rounded-2xl border border-[var(--explore-border)] bg-[var(--explore-bg-card)] p-5"
      key={key}
    >
      {block.title && (
        <h3 className="mb-2 font-semibold text-[var(--explore-text-primary)]">
          {block.title}
        </h3>
      )}
      <p className="whitespace-pre-line text-[0.95rem] text-[var(--explore-text-primary)] leading-[1.7]">
        {block.text}
      </p>
    </div>
  );
}
